import { Injectable } from '@angular/core';
import {ParentService} from '../../pages/A2-utils/ParentClass/ParentService';
import {Http} from '@angular/http';
import {constant} from '../../app.constants';
import {map} from 'rxjs/operators';
import {PlanInterface} from '../interfaces/plan.interface';
import {Observable} from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class PlanService extends ParentService {

  private setReservationPlanTypeAndRegion$ = new BehaviorSubject<boolean>(false);
  changeReservationPlanTypeAndRegion = this.setReservationPlanTypeAndRegion$.asObservable();

  private reloadReservation$ = new BehaviorSubject<boolean>(false);
  changeReloadReservation = this.reloadReservation$.asObservable();

  constructor(
    private _http: Http
  ) {
    super();
  }

  get (id: number): Observable<PlanInterface[]> {
    return this._http.get(`${constant.PLAN.LISTACTIVEPLANSINPAYOR}/${id}`, this.getHeader())
      .pipe(
        map((response: any) => response.json() as PlanInterface[]),
      );
  }

  getPlanTypes(): Observable<string[]> {
    return this._http
      .get(`${constant.PLAN.URL_PLAN_TYPES}`, this.getHeader())
      .pipe(map((response: any) => response.json()))
      .catch((error) => Observable.throw(error.json()));
  }

  setReservationPlanTypeAndRegion(tripIds: number[]): Observable<any> {
    return this._http
      .post(`${constant.PLAN.URL_SET_RESERVATION_PLAN_TYPE_AND_REGION}`, tripIds, this.getHeader())
      .pipe(map((response: any) => response.json()))
      .catch((error) => Observable.throw(error.json()));
  }

  notifyChangeReservationPlanTypeAndRegion(value: boolean) {
    this.setReservationPlanTypeAndRegion$.next(value);
  }

  notifyReloadReservation(value: boolean) {
    this.reloadReservation$.next(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/plan.service.ts